import { BlogTags as NextBlogTags } from '@graphcommerce/next-ui'
import { Chip } from '@mui/material'
import { useRouter } from 'next/router'
import { BlogTagsFragment } from './BlogTags.gql'

type BlogTagsProps = BlogTagsFragment

export function BlogTags(props: BlogTagsProps) {
  const { relatedPages } = props
  const router = useRouter()
  return (
    <NextBlogTags sx={{ display: 'flex', gap: '10px' }}>
      {relatedPages.map(({ url, title }) => {
        if (!title) return null

        return (
          <Chip
            key={url}
            onClick={() => router.push(`/${url}`)}
            label={title}
            variant='filled'
            size='medium'
            color='default'
          />
        )
      })}
    </NextBlogTags>
  )
}
